import type { ReactNode } from 'react';
import React from 'react';

import { FlagsProvider } from '@atlaskit/flag/flags-provider';

import { expVal } from '@confluence/feature-experiments';
import { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';

import { toUsableIdentityAccountId } from './toUsableIdentityAccountId.ts';

export type AnalyticsProfileIdentityProps = {
	userId?: string | null;
	fullName?: string;
	children: ReactNode;
	agent?: Record<string, never>;
};

export const AnalyticsProfileIdentity = ({
	userId,
	fullName,
	children,
	agent,
}: AnalyticsProfileIdentityProps): React.JSX.Element => {
	const usableUserId = toUsableIdentityAccountId(userId);
	if (!usableUserId || !expVal('ai_agent_analytics_cards', 'isEnabled', false)) {
		return <>{children}</>;
	}

	const card = (
		<ProfileCardWrapper
			userId={usableUserId}
			fullName={fullName}
			trigger="click"
			position="bottom-start"
			offset={[0, 8]}
			{...(agent ? { agent } : {})}
		>
			{children}
		</ProfileCardWrapper>
	);

	if (agent) {
		return <FlagsProvider>{card}</FlagsProvider>;
	}

	return card;
};
